module.exports = __webpack_public_path__ + "img/bespoke123_00.d9746343.jpg";